/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/**
 * Created by WJX on 2017/11/24.
 */


import { comment } from '@/api/ajax.js';
import { mapState } from 'vuex';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  name: '',
  mixins: [loadMore],
  props: {
    // 统一修改文字颜色
    compnentColor: {
      default: '#000'
    },

    /*
     * @name 课程名字
     * @type 课程类型 2:病例 3:资讯 ,5:直播 ,6:录播,7:点赞 8:用户帖子
     * */
    type: {
      default: 3
    },
    name: {
      default: '没有课程名字'
    },
    qaId: {
      default: ''
    },
    isCollection: {
      default: 0
    },
    needSocket: {
      default: false
    },
    editor: {
      default: ''
    }
  },
  data: function data() {
    return {
      commentObj: {
        commentCount: 0,
        list: []
      },
      isReplay: {
        // 发布类型 0 发布 1 回复 item 为被回复的信息
        type: 0,
        item: {}
      },
      showReply: false,
      //是否显示回复层
      replyValue: '',
      answerId: '',
      showMore: {
        index: -1
      },
      params: {
        pageNo: 1,
        pageSize: 20,
        questionId: '',
        type: this.type || 0
      },
      loadFlag: true,
      iosKeyInter: null
    };
  },
  methods: {
    /*
     * 初始化弹层
     * */
    initCover: function initCover() {
      this.showReply = false;
      this.showMore.index = -1;

      if (this.iosKeyInter) {
        clearInterval(this.iosKeyInter);
        this.iosKeyInter = null;
      }
    },

    /*
     * 显示更多操作
     * */
    showMoreFunc: function showMoreFunc(item, index) {
      if (this.showMore.index == index) {
        this.showMore.index = -1;
      } else {
        this.showMore.index = index;
      }
    },
    getFocus: function getFocus() {
      var _this = this;

      if (!this.$api.ios()) {
        setTimeout(function () {
          // scrollTo(0, 10)
          _this.$refs.comFirstText.focus();
        }, 500);
      }
    },

    /*
     * 点击input 显示回复层
     * */
    clickReplay: function clickReplay(item) {
      this.initCover();
      this.isReplay.type = 1;
      this.isReplay.item = item;
      this.showReply = true;
      this.getFocus();
    },
    clickRelease: function clickRelease() {
      //点击发布
      this.initCover();
      this.isReplay.type = 0;
      this.showReply = true;
      this.getFocus(); // 埋点

      this.$sa.re_interaction({
        type: '评论',
        // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        contentype: this.type,
        // 互动主体 直播，录播，资讯，病例，站内信，论坛
        contentid: this.$route.params.id,
        // 内容id
        first_cate: this.categoriesList[0].categoryName,
        //一级分类
        second_cate: this.categoriesList[1].categoryName,
        // 2级分类
        first_cate_id: this.categoriesList[0].id,
        // 1级分类id
        second_cate_id: this.categoriesList[1].id,
        //2级分类id
        author: this.editor || '',
        //讲师/作者
        contentname: this.name // location:'', //位置 站内，专区内，超级面对面内

      });
    },

    /*
     * 删除自己的评论
     * */
    selfDelete: function selfDelete(item, index) {
      var _this2 = this;

      var data = {
        id: item.id,
        questionId: item.questionId
      };
      comment.delete(data).then(function (res) {
        if (res.data.message == 'success') {
          _this2.$vux.toast.show({
            text: '删除成功',
            type: 'text',
            width: '5rem',
            position: 'bottom'
          });

          _this2.commentObj.list.splice(index, 1);

          _this2.commentObj.commentCount = _this2.commentObj.commentCount - 1;
        } else {
          _this2.$vux.toast.show({
            text: '删除失败请重试',
            type: 'cancel',
            width: '5rem'
          });
        }
      });
      this.initCover();
    },

    /*
     * 回复 @type  0 发布 1 回复
     * */
    sendReply: function sendReply() {
      var _this3 = this;

      this.showReply = true;

      if (this.replyValue.length < 300 && !/^[1]{0,3}$/.test(this.replyValue) && this.replyValue) {
        var dataObj = {
          content: this.replyValue,
          questionId: this.params.questionId || this.$route.params.id,
          type: this.type,
          commentTheme: this.name
        };

        if (this.isReplay.type) {
          dataObj = Object.assign(dataObj, {
            answerId: this.isReplay.item.id
          });
        }

        comment.addComment(dataObj).then(function (res) {
          if (res.data.message == '操作成功') {
            _this3.getComments(); //重新获取


            _this3.replyValue = '';

            _this3.initCover(); // this.$refs.comWrapper.scrollTop = 0//向上锚点定位


            try {
              document.documentElement.scrollTop = document.querySelector('.comNum').offsetTop;
            } catch (e) {}

            _this3.$vux.toast.show({
              text: '发布成功',
              type: 'text',
              width: '5rem',
              position: 'bottom'
            });
          } else if (res.data.message == 'preApproval') {
            _this3.$vux.toast.show({
              text: '发布成功，审核中',
              type: 'text',
              width: '5rem',
              position: 'bottom'
            });

            _this3.replyValue = '';

            _this3.initCover();
          } else {
            _this3.$vux.toast.show({
              text: res.data.message,
              type: 'cancel',
              width: '5rem'
            });
          }
        });
      } else {
        this.$vux.toast.show({
          text: '注意格式',
          type: 'cancel',
          width: '5rem'
        });
      }
    },

    /*
     * 举报
     * */
    accusation: function accusation(item) {
      this.$vux.toast.show({
        text: '举报已收到我们将尽快核实',
        type: 'text',
        width: '5rem',
        position: 'bottom'
      });
      this.showMore.index = -1; // let data = {
      //   id: item.id
      // }
      // comment.accusation(data).then(res => {
      //   this.initCover()
      // })
    },

    /*
     * 赞
     * */
    like: function like(item) {
      var _this4 = this;

      if (item.isLike == '1') {
        this.$vux.toast.show({
          text: '您已赞过',
          type: 'text',
          width: '5rem',
          position: 'bottom'
        });
      } else {
        comment.like({
          commentId: item.id
        }).then(function (res) {
          _this4.$set(item, 'isLike', '1');

          _this4.$set(item, 'likeCount', item.likeCount += 1);
        });
      }
    },

    /*
     * 收藏   @this.type 评论类型  2:病例 3:资讯 ,5:直播 ,6:录播,7:点赞 8:用户帖子
     * */
    collection: function collection() {
      var _this5 = this;

      var typeFunc = function typeFunc(propType) {
        var x = 1;

        switch (propType) {
          case 2:
            x = 2;
            break;

          case 3:
            x = 1;
            break;

          case 5:
            x = 4;
            break;

          case 6:
            x = 4;
            break;

          case 8:
            x = 3;
            break;

          default:
            x = 1;
        }

        return x;
      };

      var sendData = {
        id: this.$route.params.id,
        userId: this.wxUserInfo.id,
        type: typeFunc(this.type),
        // 1资讯 2病例 3帖子 4课程
        operation: this.isCollection ? 2 : 1 //1收藏 2取消

      };
      comment.collection(sendData).then(function (res) {
        _this5.$vux.toast.show({
          text: '操作成功',
          type: 'text',
          width: '5rem',
          position: 'bottom'
        });

        _this5.$emit('event-collection', _this5.isCollection ? 0 : 1);
      }); // 埋点

      this.$sa.re_interaction({
        type: '收藏',
        // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        contentype: this.type,
        // 互动主体 直播，录播，资讯，病例，站内信，论坛
        contentid: this.$route.params.id,
        // 内容id
        first_cate: this.categoriesList[0].categoryName,
        //一级分类
        second_cate: this.categoriesList[1].categoryName,
        // 2级分类
        first_cate_id: this.categoriesList[0].id,
        // 1级分类id
        second_cate_id: this.categoriesList[1].id,
        //2级分类id
        author: this.editor,
        //讲师/作者
        contentname: this.name // location:'', //位置 站内，专区内，超级面对面内

      });
    },
    focusEvent: function focusEvent() {// if (this.$api.ios()) {
      //   setTimeout(function () {//设置一个计时器，时间设置与软键盘弹出所需时间相近
      //     document.body.scrollTop = document.body.scrollHeight;//获取焦点后将浏览器内所有内容高度赋给浏览器滚动部分高度
      //   }, 1000)
      // }
    },
    getComments: function getComments() {
      var pageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      var qaId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$route.params.id;
      var data = {
        pageNo: 1,
        pageSize: 20,
        questionId: qaId,
        type: this.type || 0
      };
      this.params = data;
      this.loadFlag = true; //重置加载更多

      this.commentObj.list = [];
      this.getList(this.params);
    },
    getList: function getList(params) {
      var _this6 = this;

      if (this.loadFlag) {
        this.loadFlag = false;
        comment.getComments(params).then(function (res) {
          var resData = res.data.data;
          _this6.commentObj.commentCount = resData.total;

          var _iterator = _createForOfIteratorHelper(resData.list),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;

              _this6.commentObj.list.push(item);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (resData.list.length < _this6.params.pageSize) {
            _this6.loadFlag = false;
            return false;
          } else {
            _this6.params.pageNo += 1;
            _this6.loadFlag = true;
          }
        });
      }
    },
    getPre: function getPre() {
      this.getList(this.params);
    },
    audioPlay: function audioPlay(e) {
      document.querySelectorAll('.voice-animate').forEach(function (item, index) {
        item.className = item.className.replace('playing', ' ');
      });
      document.querySelectorAll('audio').forEach(function (item, index) {
        item.pause();
      });

      if (e.target.className == 'audioDiv') {
        e.target.children[0].className = e.target.children[0].className + ' playing';
        e.target.children[2].play();
      } else if (e.target.parentNode.className == 'audioDiv') {
        e.target.parentNode.children[2].play();
        e.target.children[0].className = e.target.children[0].className + ' playing';
      }
    }
  },
  computed: _objectSpread({}, mapState({
    wxUserInfo: function wxUserInfo(state) {
      return state.wxUserInfo;
    },
    categoriesList: function categoriesList(state) {
      return state.categoriesList;
    }
  })),
  watch: {
    qaId: {
      handler: function handler(v) {
        if (v) {
          this.commentObj = {
            commentCount: 0,
            list: []
          };
          this.loadFlag = true;
          this.params = {
            pageNo: 1,
            pageSize: 20,
            questionId: v,
            type: this.type || 0
          };
          this.getPre();
        }
      },
      immediate: true
    }
  },
  components: {},
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  beforeDestroy: function beforeDestroy() {}
};